import { IOptionsWithTypes } from '@eventr/common'
import { Stack } from '@mui/material'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { useUserFilter } from '../hooks/useUserFilter'
import { CardText } from '../subComponents/cardText'
import { Counter } from '../subComponents/counter'
import { UsersList } from '../subComponents/usersLists'
interface ParkingPassengersProps {
    passengers: IOptionsWithTypes[]
}

export const ParkingPassengers = ({ passengers }: ParkingPassengersProps) => {
    const { filterUsers } = useUserFilter()
    const count = filterUsers(passengers).length
    return (
        <Stack spacing={'8px'}>
            <Stack direction={'row'} justifyContent={'space-between'}>
                <CardText variant="bodyBold">
                    {cardTranslation('Passengers')}
                </CardText>
                <Counter count={count} />
            </Stack>
            <UsersList userList={passengers} />
        </Stack>
    )
}
